module.exports = __webpack_public_path__ + "img/img_dog.9d6163b1.png";